import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge only knows Tailwind's stock scales. Our design system defines
 * custom font-size tokens in `src/styles.css` (`--text-display-xl`, `--text-h3`,
 * `--text-body`, …), and out of the box tailwind-merge classifies `text-h3`,
 * `text-body-lg`, `text-eyebrow`, etc. as *text colour* classes. Combined with a
 * real colour in one cn() call — `cn("text-h3", "text-ink-900")` — it silently
 * drops the size token and the type renders at the inherited size (16px).
 *
 * Registering the scale under the `font-size` class group makes size and colour
 * coexist, while `text-h3 text-h2` still resolves to the last one. Do not remove
 * this: the failure mode is silent, site-wide, and only visible by measuring
 * computed font-size in the browser.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display-xl",
            "display-lg",
            "h2",
            "h3",
            "body-lg",
            "body",
            "body-sm",
            "eyebrow",
            "stat",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
